'use client'

import { useEffect } from 'react'

import { useLibraryStore } from '../../stores/useLibraryStore'

import { Document } from '@/features/library/types/document'
import { useLibraryAnalytics } from '@/shared/lib/analytics'
import { Modal, ModalTitle, ModalDescription } from '@/shared/ui/Modal'

import { DocumentModalButton } from './Button'



interface DocumentModalProps {
  documentId: number
}

export function DocumentModal({ documentId }: DocumentModalProps) {
  const { document } = useLibraryStore({ id: documentId })
  const { trackDocumentViewed } = useLibraryAnalytics()

  useEffect(() => {
    if (document) {
      trackDocumentViewed(document)
    }
  }, [document, trackDocumentViewed])

  if (!document) return null

  return (
    <Modal className="sm:max-w-2xl">
      {document?.image?.file?.url && (
        <div className="relative w-full h-[200px] overflow-hidden rounded-t-xl">
          <img
            src={document?.image?.file?.url ?? ''}
            alt={document.name}
            className="w-full h-full object-cover object-center"
          />
        </div>
      )}

      <div className="bg-linear-to-t from-[#E4E8FA] to-[#DDD4FF] p-4 rounded-lg flex flex-col items-start">
        <ModalTitle className="text-xl text-primary-dark font-bold block">
          {document?.name}
        </ModalTitle>

        {document?.text_content && (
          <ModalDescription
            className="text-dark leading-relaxed text-sm font-semibold font-[#1D1D2A] block"
            dangerouslySetInnerHTML={{ __html: document?.text_content }}
          />
        )}
      </div>

      {document?.archive_kind === 'embedded' && document?.embedded_code && (
        <div
          className="w-full overflow-hidden rounded-lg [&_iframe]:w-full [&_iframe]:aspect-video"
          dangerouslySetInnerHTML={{ __html: document.embedded_code }}
        />
      )}

      <DocumentModalButton {...document} />
    </Modal>
  )
}
